<template>
  <b-nav  class="nav-toggled" >
    <router-link to="/">
        <img class="Item toToggle2"
              src="@/assets/PentagroIcon2.png"
              style="cursor: pointer;"
              :alt="$t('icone-pentagro')" />
      </router-link>
    <b-nav-item-dropdown class="toggled" no-caret :text="$t('iniciar')" left>
      <b-dropdown-item class="drop-item" @click="switchOnLineMode"
        to="/"
        v-if="user.Permissions.aceitarplanejamento.allowed && user.Permissions.aceitarplanejamento.permission"
      >
        <img
          class="dropItem"
          src="@/assets/aceitarplanejamento.png"
          :alt="$t('planejamento')"
        />
        {{isOnlineRunning == false ?  user.Permissions.aceitarplanejamento.permission : user.Permissions.pararsimulacaoonline.permission}}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        @click="switchRotationScreen"
        v-if="hasScreenRotation"
        >
        <img
          class="dropItem"
          src="@/assets/configuracoes.png"
          :alt="$t('planejamento')"
        />
        {{ !rotationScreen ?  $t('ativar-rotacao-de-telas-de-monitoramento')  : $t('desativar-rotacao-de-telas-de-monitoramento')}}
      </b-dropdown-item>

      <b-dropdown-item
        class="drop-item"
        hide-header
        v-b-modal.workShiftClosing
        v-if="
          user.role == 'PGDI' &&
          user.Permissions.fechamentodeturno.allowed &&
          user.Permissions.fechamentodeturno.permission
        "
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          :alt="$t('fechamento-de-turno')"
        />
        {{ user.Permissions.fechamentodeturno.permission }}
      </b-dropdown-item>

      <template v-for="item in ocDropdownList">
        <DropDownItem 
          v-if="item.route"
          :key=item.item 
          :image=item.image 
          :route=item.route 
          :modal=item.modal
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItem>
        <DropDownItemModal 
          v-if="item.modal"
          :key=item.item 
          :image=item.image 
          :modal=item.modal
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItemModal>
      </template>
    </b-nav-item-dropdown>

    <b-modal id="modalReliabilitySystem" hide-footer :title="$t('configurar-aderencia')">
      <reliability-system></reliability-system>
    </b-modal>

    <b-modal id="screenrotation" size="lg" hide-footer :title="$t('configurar-rotacao-de-telas')">
      <ScreenRotation></ScreenRotation>
    </b-modal>

    <b-modal
      id="askConfirmClosingUnit"
      size="md"
      hide-footer
      :title="$t('atencao')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
      class='msgBox'
      :question="$t('tem-certeza-que-deseja-forcar-o-fechamento')"
      modelname="askConfirmClosingUnit"
      v-bind:action="forcePerformanceIndicatorTreeClosing" 
      />
    </b-modal>

        <b-modal
      id="workShiftClosing"
      :title="$t('fechamento-de-turno-0')"
      size="xl"
      hide-footer
      :no-close-on-backdrop="true"
    >
      <WorkShiftClosing></WorkShiftClosing>
    </b-modal>

     <b-modal
      id="askConfirmActiveAutonomousModeGDI"
      size="md"
      centered
      hide-footer
      :title="$t('atencao')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        class="msgBox"
        :question="
          autonomousMode == 0
            ? $t('deseja-ativar-o-modo-autonomo')
            : $t('deseja-desativar-o-modo-autonomo')
        "
        modelname="askConfirmActiveAutonomousModeGDI"
        v-bind:action="switchAutonomousMode"
      />
    </b-modal>

  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, defaultSuccess } from "@/global";
import DropDownItem from "./DropDownItem.vue"
import DropDownItemModal from "./DropDownItemModal.vue"
import reliabilitySystem from "../reliabilitySystem/reliabilitySystem";
import axios from "axios";
import ScreenRotation from "../screenRotation/ScreenRotation"
import MessageBox from './MessageBoxModal.vue';
import WorkShiftClosing from "../workshift/WorkShiftClosing.vue";
// eslint-disable-next-line no-unused-vars
import simulatorConfig from "../simulator/simulatorConfig.vue";

export default {
  name: "IniciarDropdownGDI",

  components: { 
    reliabilitySystem, 
    ScreenRotation, 
    MessageBox,
    DropDownItem,
    DropDownItemModal,
    WorkShiftClosing
  },

  computed: mapState(["user", "isOnlineRunning", "rotationScreen", "autonomousMode"]),
  data() {
    return {
      hasScreenRotation: false,
      ocDropdownList: [],
      validKeys: {
        configurarpesoskpisdesempenho: {
          item: "configurarpesoskpisdesempenho",
          image: "dashboard.png",
          route: "/weight",
          index: 1,
        },
        alterarmodorotacao: {
          item: "alterarmodorotacao",
          image: "dashboard.png",
          index: 2
        },
        revisarproducao: {
          item: "revisarproducao",
          image: "dashboard.png",
          route: "/reviewproduction",
          index: 3
        },
        atualizardesempenho: {
          item: "atualizardesempenho",
          image: "dashboard.png",
          modal: "askConfirmClosingUnit",
          index: 4
        },
        configuraraderencia: {
          item: "configuraraderencia",
          image: "configurar.png",
          modal: "modalReliabilitySystem",
          index: 5
        },
        configurarrotacaodetelas: {
          item: "configurarrotacaodetelas",
          image: "configurar.png",
          modal: "screenrotation",
          index: 6,
        }
      }
    }
  },

  methods:{
    LoadPermission(){
      for (let key in this.user.Permissions){
        if(this.validKeys[key] && this.user.Permissions[key].allowed)
          this.ocDropdownList.push({
            ...this.user.Permissions[key], 
            ...this.validKeys[key]
          })
      }

      this.ocDropdownList.sort((a, b) => a.index > b.index ? 1 : a.index < b.index ? -1 : 0)
    },

    async loadRotationScreen(){
      let system = this.user.role == "GDI" ? "G" : "P";
      let userUnitId = this.user.UnitId;
      let userId = this.user.Id;

      await axios.get(`${urlMainAPI}/getscreenrotationsettings/${system}/${userUnitId}/${userId}`)
        .then( async (res) => {
          if(res.data){
            let index = 0;
            res.data.routes.forEach(screen => {
              if(screen.rotation)
                index++;
            });
            this.hasScreenRotation = index > 1 ? true : false;
          }
        })
        .catch();
    },

    switchOnLineMode(){
      const url = `${urlMainAPI}/switchonlinemode`;
      axios
        .post(url)
        .then(res =>{
          defaultSuccess(res.data);
          this.$store.commit("setIsOnlineRunning", !this.isOnlineRunning);
          this.$store.dispatch("getOnlineModeStatus");
        })
        .catch();
    },

    switchAutonomousMode() {
      const url = `${urlMainAPI}/switchautonomousmode`;

      axios
        .post(url)
        .then((res) => {
          if (res.status == 200 && this.autonomousMode == 0)
            defaultSuccess(this.$t('modo-autonomo-ativado-com-sucesso'))
          else
            defaultSuccess(this.$t('modo-autonomo-desativado-com-sucesso'))

          this.$store.commit("setAutonomousMode", this.autonomousMode == 1 ? 0 : 1);
        })
        .catch((err) => {
          this.$store.commit("setAutonomousMode", this.autonomousMode == 1 ? 0 : 1);
          console.error(err);
        });
    },

    switchRotationScreen(){
      let backup = {...this.rotationScreen};
      this.$store.commit("setRotationScreen", !this.rotationScreen);

      if(backup != this.rotationScreen && this.rotationScreen == true){
        defaultSuccess(this.$t('rotacao-de-telas-ativado'));
      }else if(backup != this.rotationScreen && this.rotationScreen == false){
        defaultSuccess(this.$t('rotacao-de-telas-desativada'));
      }
    },

    forcePerformanceIndicatorTreeClosing(){
      defaultSuccess(this.$t('iniciado-o-processo-para-recalcular-a-arvore-de-indicadores'));
      const url = `${urlMainAPI}/forceperformanceindicatorclosing`;
      axios.get(url)
        .then(res =>{
          defaultSuccess(res.data);
        })
        .catch(e => console.log('Erro :>> ' + e));
    },
  },

  mounted() {
    this.loadRotationScreen();
    this.LoadPermission();
  },
};
</script>

<style scoped>
img.Item {
  max-height: 33px;
  max-width: 33px;
  border-radius: 5px;
}

.toggled{
  padding-right: 0;
}

.nav-toggled{
  display: flex;
  min-width: 100px;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
 
}
</style>

